var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMoreFilter = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 21 17",
    fill: "black",
    style: {
      marginTop: 7
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14H7V16H0V14ZM0 7H9V9H0V7ZM0 0H20V2H0V0ZM18.674 9.025L19.83 8.634L20.83 10.366L19.914 11.171C20.0293 11.7177 20.0293 12.2823 19.914 12.829L20.83 13.634L19.83 15.366L18.674 14.975C18.264 15.345 17.776 15.63 17.239 15.805L17 17H15L14.76 15.804C14.2293 15.6306 13.7408 15.3478 13.326 14.974L12.17 15.366L11.17 13.634L12.086 12.829C11.9707 12.2823 11.9707 11.7177 12.086 11.171L11.17 10.366L12.17 8.634L13.326 9.025C13.736 8.655 14.224 8.37 14.761 8.195L15 7H17L17.24 8.196C17.776 8.37 18.264 8.656 18.674 9.026V9.025ZM16 14C16.5304 14 17.0391 13.7893 17.4142 13.4142C17.7893 13.0391 18 12.5304 18 12C18 11.4696 17.7893 10.9609 17.4142 10.5858C17.0391 10.2107 16.5304 10 16 10C15.4696 10 14.9609 10.2107 14.5858 10.5858C14.2107 10.9609 14 11.4696 14 12C14 12.5304 14.2107 13.0391 14.5858 13.4142C14.9609 13.7893 15.4696 14 16 14Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoreFilter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/More_Filter.ab115c8a.svg";
export { ForwardRef as ReactComponent };